// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"976107a8","349":"ab4e200e","438":"58f554d0"}[chunkId] + ".chunk.js";
};